import Hub from './components/common/Hub'
import { SWRConfig } from 'swr'
import cache from './utils/cache'
import type { VFC } from 'react'
import type { AuthState } from '@sparky/framework'

export { useAppInfoModule } from './components/homepage/AppInfo'
export { isRunningStatus } from './utils/common'

const swrConfig = {
  provider: () => cache
}

cache.init()

const HubSWR: VFC<{ auth: AuthState }> = ({ auth }) => (
  <SWRConfig value={swrConfig}>
    <Hub auth={auth} />
  </SWRConfig>
)

export default HubSWR
